<template>
  <div>
    <div
      class="text-center"
      v-if="!dataLoaded"
    >
      <v-progress-circular
        class="mt-6"
        color="primary"
        :size="50"
        indeterminate
      />
    </div>
    <div
      class="mt-4"
      v-show="dataLoaded"
    >
      <v-row class="my-0">
        <v-col
          cols="12"
          class="py-0"
        >
          <v-card class="py-2 px-4 mb-1 base-card d-flex justify-end align-center shadow">
            <div class="mr-auto ml-4">
              <span class="font-weight-bold">Данные о работе в журналах</span>
            </div>
            <v-btn
              outlined
              small
              color="primary"
              class="action-btn elevation-0 rounded-lg"
              height="32"
              @click="create"
            >
              <v-icon class="uikit-icon plus primary size-20" />
              <span class="btn-text">Добавить работу в журнале</span>
            </v-btn>
            <v-btn
              class="ml-1 pl-0"
              title="Поиск"
              icon
              @click="showSearch()"
            >
              <v-icon class="uikit-icon search" />
            </v-btn>
            <v-btn
              icon
              class="ml-1"
              title="Фильтр"
              @click="showFilter()"
            >
              <v-icon class="uikit-icon filter size-20" />
            </v-btn>
          </v-card>
        </v-col>
      </v-row>

      <v-row
        class="mb-0"
        :class="isShowFilter || isShowSearch ? 'mt-3' : 'mt-0'"
      >
        <v-col
          cols="12"
          class="py-0"
        >
          <journals-filter
            :show-filter="isShowFilter"
            :show-search="isShowSearch"
            @apply-filters="handleFilterChange"
          />
        </v-col>
      </v-row>

      <v-row class="my-0">
        <v-col
          cols="12"
          class="pt-0"
        >
          <v-card
            ref="mainCard"
            class="base-card pb-4 px-4 shadow"
          >
            <v-data-table
              ref="table"
              class="base-table fixed-last-column shadow-for-last-column is-vertical-scroll elevation-0 mt-2"
              :class="{ 'shadow-last-column': isShadowForLastColumn }"
              :headers="tableHeaders"
              :items="journalEditorialBoardParent.list"
              loading-text="Загрузка"
              no-data-text="Нет данных"
              no-result-text="Не найдено"
              hide-default-footer
              :loading="tableLoading"
              fixed-header
              :items-per-page="-1"
              v-scroll.self="tableScroll"
            >
              <template v-slot:item.index="{ index }">
                {{ index + 1 }}
              </template>
              <template v-slot:item.quarter="{ item }">
                {{ getPeriodQuarter(item) }}
              </template>
              <template v-slot:item.statementDate="{ item }">
                {{ getAcceptanceStatus(item) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <div class="table-icons">
                  <v-icon
                    v-if="
                      [
                        workStatusListName.Draft,
                        workStatusListName.Review,
                        workStatusListName.Revision,
                        workStatusListName.Accepted,
                        workStatusListName.Rejected,
                        workStatusListName.Actualization
                      ].includes(workStatusList[item.commonWork?.status.id])
                    "
                    class="uikit-icon eye show-btn"
                    title="Открыть"
                    @click="show(item)"
                  />
                  <v-icon
                    v-if="
                      [
                        workStatusListName.Draft,
                        workStatusListName.Revision,
                        workStatusListName.Actualization
                      ].includes(workStatusList[item.commonWork?.status.id])
                    "
                    class="uikit-icon edit-icon edit-btn"
                    title="Редактировать"
                    @click="edit(item)"
                  />
                  <v-icon
                    v-if="
                      (isModerator || isAdmin) &&
                      [workStatusListName.Review].includes(workStatusList[item.commonWork?.status.id])
                    "
                    class="uikit-icon arrow-top-right-bold-box-outline show-btn"
                    title="Перейти к работе"
                    @click="process(item)"
                  />
                  <v-icon
                    v-if="[workStatusListName.Review].includes(workStatusList[item.commonWork?.status.id])"
                    class="uikit-icon vector-left remove-btn"
                    @click="returnWork(item)"
                    title="Вернуть с рассмотрения"
                  />
                  <v-icon
                    v-if="
                      [workStatusListName.Draft, workStatusListName.Actualization].includes(
                        workStatusList[item.commonWork?.status.id]
                      )
                    "
                    class="uikit-icon trash remove-btn"
                    title="Удалить"
                    @click="remove(item)"
                  />
                </div>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <ConfirmDialog
      :dialog="isConfirmDialog"
      :loading="deleteLoading"
      @closeConfirmModal="closeConfirmDialog"
      @confirm="deleteJournal"
      message="Подтвердите удаление работы"
    />
  </div>
</template>

<script>
import { commonWorkApi } from '@/api'
import { shadowForLastColumn } from '@/mixins/shadowForLastColumn'
import { tableHeight } from '@/mixins/tableHeight'
import { isVerticalScrollInTable } from '@/mixins/isVerticalScrollInTable'
import { mapGetters } from 'vuex'
import JournalsFilter from '@/components/JournalEditorialBoards/JournalsFilter.vue'
import ConfirmDialog from '@/components/dialogs/Confirm'
import { journalEditorialBoardApi } from '../../api'
import { JournalEditorialBoardParent } from '../../models/JournalEditorialBoards'
import { DynamicFilters } from '../../models/Filters'
import { workStatusList, workStatusListName } from '@/scripts/consts'
import { formatDateReverseFromISO } from '../../scripts/formatDate'
export default {
  name: 'Journals',

  metaInfo: {
    title: 'Участие в работе редакционных коллегий журналов'
  },
  mixins: [shadowForLastColumn, tableHeight, isVerticalScrollInTable],
  components: {
    JournalsFilter,
    ConfirmDialog
  },

  data() {
    return {
      tableHeaders: [
        { text: '№', value: 'index', sortable: false, align: 'start' },
        { text: 'Статус', value: 'commonWork.status.name', sortable: false, align: 'start' },
        { text: 'Квартал', value: 'quarter', sortable: false, align: 'start' },
        { text: 'Подразделение', value: 'employeePosition.department.name', sortable: false, align: 'start' },
        { text: 'Наименование издания', value: 'magazine.name', sortable: false, align: 'start' },
        { text: 'Роль', value: 'editorialBoardRole.name', sortable: false, align: 'start' },
        { text: 'Дата принятия', value: 'statementDate', sortable: false, align: 'start' },
        { text: 'Действия', value: 'actions', sortable: false, align: 'end', width: '120px' }
      ],
      journalEditorialBoardParent: new JournalEditorialBoardParent(),
      dynamicFilters: new DynamicFilters(),
      dataLoaded: true,
      isShowFilter: false,
      isShowSearch: false,
      isConfirmDialog: false,
      deleteLoading: false,
      selectedItem: null,
      tableLoading: false,
      pageNumber: 0,
      lastPage: false,
      total: 0
    }
  },

  async created() {
    await this.getAllJournals()
  },

  computed: {
    ...mapGetters('user', ['isAdmin', 'isModerator']),
    workStatusListName() {
      return workStatusListName
    },

    workStatusList() {
      return workStatusList
    }
  },
  methods: {
    formatDateReverseFromISO,
    show(item) {
      const url = '/journal-editorail-boards/journals' + '/show/' + item.id
      this.$router.push(url)
    },
    create() {
      const url = '/journal-editorail-boards/journals' + '/edit/0'
      this.$router.push(url)
    },
    edit(item) {
      const url = '/journal-editorail-boards/journals' + '/edit/' + item.id
      this.$router.push(url)
    },
    process(item) {
      const url = '/journal-editorail-boards/journals' + '/process/' + item.id
      this.$router.push(url)
    },
    remove(item) {
      this.selectedItem = item
      this.isConfirmDialog = true
    },

    closeConfirmDialog() {
      this.selectedItem = null
      this.isConfirmDialog = false
    },
    getAcceptanceStatus(item) {
      if (item.commonWork.status.id == 3 || item.commonWork.status.id == 6) {
        return this.formatDateReverseFromISO(item.commonWork.statementDate)
      } else return '-'
    },
    getPeriodQuarter(item) {
      if (item.commonWork.status.id == 3 || item.commonWork.status.id == 6) {
        return item.commonWork.period.quarter.name + ' ' + item.commonWork.period.year.year + ' г.'
      } else return '-'
    },
    async returnWork(item) {
      try {
        await commonWorkApi.returnFromReview(item.commonWork?.id)
        item.commonWork.status = { id: 1, name: 'Черновик' }
        this.$toast.info('Успешно возвращено с рассмотрения')
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Ошибка возвращения с рассмотрения')
      }
    },
    async handleFilterChange(filters) {
      this.pageNumber = 0
      this.lastPage = false
      this.journalEditorialBoardParent.list = []

      await this.getAllJournals(filters)
    },

    async getAllJournals(filters = {}) {
      try {
        if (this.lastPage) return

        this.tableLoading = true
        const { content, last, totalElements } = await journalEditorialBoardApi.findAll(this.pageNumber, filters)
        this.lastPage = last
        this.total = totalElements
        this.pageNumber++

        content.length &&
          content.forEach(obj => {
            this.journalEditorialBoardParent.add(obj)
          })
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Не удалось получить список работ')
      } finally {
        this.tableLoading = false
        this.dataLoaded = true
      }
    },

    async deleteJournal() {
      this.deleteLoading = true
      try {
        await journalEditorialBoardApi.remove(this.selectedItem.id)
        this.$toast.info('Успешно удалено')
        this.journalEditorialBoardParent.remove(this.selectedItem.id)
        this.isConfirmDialog = false
        this.pageNumber--
        this.lastPage = false
        this.total = 0
        this.getAllJournals()
      } catch (e) {
        this.showErrorMessage(e, 'Не удалось удалить работу')
      } finally {
        this.deleteLoading = false
      }
    },

    showSearch() {
      this.isShowSearch = !this.isShowSearch
      this.isShowFilter = false
      this.setTableHeight()
    },

    showFilter() {
      this.isShowFilter = !this.isShowFilter
      this.isShowSearch = false
      this.setTableHeight()
    },
    tableScroll(event) {
      const el = event.target
      if (el.scrollHeight - el.clientHeight - el.scrollTop <= 10 && !this.tableLoading) {
        this.getAllJournals()
      }
    }
  }
}
</script>

<style scoped></style>
